/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatMoney } from "../functions/format-money.js";

const __vue_script__ = {
  props: ["value", "currency", "type"],
  data() {
    return {
      selectedInstallments: (window.offer?.order_bumps || []).map(data => Object.keys(data.installments).length),
      orderBumps: window.offer?.order_bumps
    }
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(checked) {
        console.log(checked)
        this.$emit("input", checked);
        this.emitChangeInstallments();
      }
    }
  },
  watch: {
    selectedInstallments() {
      this.emitChangeInstallments();
    }
  },
  methods: {
    emitChangeInstallments() {
      this.$emit("change-installments", this.orderBumps.reduce((acc, data, index) => {
        acc[data.offer_code] = parseInt(this.selectedInstallments[index]);
        return acc
      }, {}));
    },
    formatDescription(data) {
      return data.description.split("&lt;br/&gt;");
    },
    installments(data) {
      var decSep = this.currency.prefix === "R$" ? ',' : '.';
      var thouSep = this.currency.prefix === "R$" ? '.' : ',';

      var installments = data.installments;
      if (window.is_foreign) {
        installments = { 1: installments[1] };
      }

      var result = [];
      var hasInterest = !window.product.is_tax_to_producer;
      for (var i in installments) {
        var value = installments[i];
        result.push({
          id: i,
          name: `${i} x ${this.currency.prefix} ${formatMoney(value * this.currency.value, 2, decSep, thouSep)}${i > 1 && hasInterest ? '*' : ''}`,
          value: i * value
        });
      }

      if (window.product.order_installment === "desc") {
        return result.reverse();
      }

      return result;
    }
  },
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderBumps && _vm.orderBumps.length > 0
    ? _c("div", { staticClass: "multiple-order-bump card" }, [
        _c("div", { staticClass: "card-header text-center" }, [
          _vm._v("Aproveite também para comprar"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          _vm._l(_vm.orderBumps, function (data, index) {
            return _c("div", { key: index, staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("div", { staticClass: "media flex-fill" }, [
                    data.picture
                      ? _c("img", {
                          staticClass: "mr-3",
                          attrs: {
                            src: "https://static.velora.com.br/" + data.picture,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "media-body" }, [
                      _c("h6", {
                        staticClass: "mb-0",
                        domProps: { innerHTML: _vm._s(data.name) },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "description d-none d-md-block mt-2" },
                        [
                          data.description
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.formatDescription(data),
                                  function (d) {
                                    return _c("div", {
                                      key: d,
                                      staticClass: "py-1",
                                      domProps: { innerHTML: _vm._s(d) },
                                    })
                                  }
                                ),
                                0
                              )
                            : _c("span", [_vm._v("Produto")]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h5",
                    { staticClass: "price mb-0 pl-2" },
                    [
                      _c("format-money", {
                        attrs: { currency: _vm.currency, value: data.price },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description d-md-none mt-2" }, [
                  data.description
                    ? _c(
                        "div",
                        _vm._l(_vm.formatDescription(data), function (d) {
                          return _c("div", {
                            key: d,
                            staticClass: "py-1",
                            domProps: { innerHTML: _vm._s(d) },
                          })
                        }),
                        0
                      )
                    : _c("span", [_vm._v("Produto")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row align-items-end justify-content-end mt-3",
                  },
                  [
                    _vm.type === "card"
                      ? _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("form-group", {
                              staticClass: "mb-0",
                              attrs: {
                                label: "Parcelamento",
                                id: "installments" + index,
                                select: true,
                                options: _vm.installments(data),
                              },
                              model: {
                                value: _vm.selectedInstallments[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedInstallments, index, $$v)
                                },
                                expression: "selectedInstallments[index]",
                              },
                            }),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-secondary" }, [
                              _vm._v("O valor será cobrado separadamente"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6 pt-3" }, [
                      _c("div", { staticClass: "form-check text-md-right" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checked,
                              expression: "checked",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            id: "order-bump-checkbox" + index,
                          },
                          domProps: {
                            value: data.offer_code,
                            checked: Array.isArray(_vm.checked)
                              ? _vm._i(_vm.checked, data.offer_code) > -1
                              : _vm.checked,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = data.offer_code,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checked = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checked = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "order-bump-checkbox" + index },
                          },
                          [
                            _vm._v(
                              "\n                Adicionar produto\n              "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-36c03446_0", { source: ".multiple-order-bump {\n  border-radius: 4px !important;\n  border-color: #C08811 !important;\n  border: 1px dashed rgba(0, 0, 0, 0.3);\n  box-shadow: none;\n}\n.multiple-order-bump > .card-header {\n  color: #803F02;\n  border-radius: 4px !important;\n  padding: 8px 16px;\n  background: #FBEBC1;\n  font-weight: bold;\n  font-size: 16px;\n  border-bottom: none;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.multiple-order-bump .price {\n  white-space: nowrap;\n}\n.multiple-order-bump .description {\n  display: block;\n  font-size: 14px;\n  line-height: 130%;\n  color: #928F98;\n}\n.multiple-order-bump > .card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 16px 12px;\n}\n.multiple-order-bump > .card-body hr {\n  border-color: rgba(0, 0, 0, 0.3);\n}\n.multiple-order-bump > .card-body .card {\n  border-radius: 4px !important;\n  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1215686275);\n}\n.multiple-order-bump > .card-body .media {\n  align-items: center;\n}\n.multiple-order-bump > .card-body .media img {\n  max-width: 56px;\n  max-height: 56px;\n  min-width: 56px;\n  min-height: 56px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n.multiple-order-bump small {\n  font-size: 10px;\n  opacity: 0.8;\n}\n\n/*# sourceMappingURL=multiple-order-bump.vue.map */", map: {"version":3,"sources":["frontend/components/multiple-order-bump.vue","multiple-order-bump.vue"],"names":[],"mappings":"AAmIA;EACA,6BAAA;EACA,gCAAA;EACA,qCAAA;EACA,gBAAA;AClIA;ADoIA;EACA,cAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;AClIA;ADqIA;EACA,mBAAA;ACnIA;ADsIA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACpIA;ADuIA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;ACrIA;ADuIA;EACA,gCAAA;ACrIA;ADwIA;EACA,6BAAA;EACA,wDAAA;ACtIA;ADyIA;EACA,mBAAA;ACvIA;ADyIA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ACvIA;AD4IA;EACA,eAAA;EACA,YAAA;AC1IA;;AAEA,kDAAkD","file":"multiple-order-bump.vue","sourcesContent":["<template>\n  <div v-if=\"orderBumps && orderBumps.length > 0\" class=\"multiple-order-bump card\">\n    <div class=\"card-header text-center\">Aproveite também para comprar</div>\n    <div class=\"card-body\">\n      <div v-for=\"(data, index) in orderBumps\" :key=\"index\" class=\"card\">\n        <div class=\"card-body\">\n          <div class=\"d-flex align-items-center\">\n            <div class=\"media flex-fill\">\n              <img v-if=\"data.picture\" :src=\"'https://static.velora.com.br/' + data.picture\" class=\"mr-3\">\n              <div class=\"media-body\">\n                <h6 class=\"mb-0\" v-html=\"data.name\" />\n                <div class=\"description d-none d-md-block mt-2\">\n                  <div v-if=\"data.description\">\n                    <div v-for=\"d in formatDescription(data)\" :key=\"d\" v-html=\"d\" class=\"py-1\" />\n                  </div>\n                  <span v-else>Produto</span>\n                </div>\n              </div>\n            </div>\n            <h5 class=\"price mb-0 pl-2\">\n              <format-money :currency=\"currency\" :value=\"data.price\" />\n            </h5>\n          </div>\n          <div class=\"description d-md-none mt-2\">\n            <div v-if=\"data.description\">\n              <div v-for=\"d in formatDescription(data)\" :key=\"d\" v-html=\"d\" class=\"py-1\" />\n            </div>\n            <span v-else>Produto</span>\n          </div>\n          <div class=\"row align-items-end justify-content-end mt-3\">\n            <div v-if=\"type === 'card'\" class=\"col-md-6\">\n              <form-group\n                class=\"mb-0\"\n                v-model=\"selectedInstallments[index]\"\n                label=\"Parcelamento\"\n                :id=\"'installments' + index\"\n                :select=\"true\"\n                :options=\"installments(data)\"\n              />\n              <small class=\"text-secondary\">O valor será cobrado separadamente</small>\n            </div>\n            <div class=\"col-md-6 pt-3\">\n              <div class=\"form-check text-md-right\">\n                <input\n                  class=\"form-check-input\"\n                  type=\"checkbox\"\n                  v-model=\"checked\"\n                  :id=\"'order-bump-checkbox' + index\"\n                  :value=\"data.offer_code\"\n                >\n                <label class=\"form-check-label\" :for=\"'order-bump-checkbox' + index\">\n                  Adicionar produto\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { formatMoney } from \"../functions/format-money.js\";\n\nexport default {\n  props: [\"value\", \"currency\", \"type\"],\n  data() {\n    return {\n      selectedInstallments: (window.offer?.order_bumps || []).map(data => Object.keys(data.installments).length),\n      orderBumps: window.offer?.order_bumps\n    }\n  },\n  computed: {\n    checked: {\n      get() {\n        return this.value;\n      },\n      set(checked) {\n        console.log(checked)\n        this.$emit(\"input\", checked);\n        this.emitChangeInstallments();\n      }\n    }\n  },\n  watch: {\n    selectedInstallments() {\n      this.emitChangeInstallments();\n    }\n  },\n  methods: {\n    emitChangeInstallments() {\n      this.$emit(\"change-installments\", this.orderBumps.reduce((acc, data, index) => {\n        acc[data.offer_code] = parseInt(this.selectedInstallments[index]);\n        return acc\n      }, {}));\n    },\n    formatDescription(data) {\n      return data.description.split(\"&lt;br/&gt;\");\n    },\n    installments(data) {\n      var decSep = this.currency.prefix === \"R$\" ? ',' : '.';\n      var thouSep = this.currency.prefix === \"R$\" ? '.' : ',';\n\n      var installments = data.installments;\n      if (window.is_foreign) {\n        installments = { 1: installments[1] };\n      }\n\n      var result = [];\n      var hasInterest = !window.product.is_tax_to_producer;\n      for (var i in installments) {\n        var value = installments[i];\n        result.push({\n          id: i,\n          name: `${i} x ${this.currency.prefix} ${formatMoney(value * this.currency.value, 2, decSep, thouSep)}${i > 1 && hasInterest ? '*' : ''}`,\n          value: i * value\n        });\n      }\n\n      if (window.product.order_installment === \"desc\") {\n        return result.reverse();\n      }\n\n      return result;\n    }\n  },\n}\n</script>\n\n<style lang=\"scss\">\n.multiple-order-bump {\n  border-radius: 4px !important;\n  border-color: #C08811 !important;\n  border: 1px dashed rgba(0, 0, 0, 0.3);\n  box-shadow: none;\n\n  > .card-header {\n    color: #803F02;\n    border-radius: 4px !important;\n    padding: 8px 16px;\n    background: #FBEBC1;\n    font-weight: bold;\n    font-size: 16px;\n    border-bottom: none;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n  }\n\n  .price {\n    white-space: nowrap;\n  }\n\n  .description {\n    display: block;\n    font-size: 14px;\n    line-height: 130%;\n    color: #928F98;\n  }\n\n  > .card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px 16px 12px;\n\n    hr {\n      border-color: rgba(0, 0, 0, 0.3);\n    }\n\n    .card {\n      border-radius: 4px !important;\n      box-shadow: 0px 0px 16px 0px #0000001F;\n    }\n\n    .media {\n      align-items: center;\n\n      img {\n        max-width: 56px;\n        max-height: 56px;\n        min-width: 56px;\n        min-height: 56px;\n        border-radius: 6px;\n        object-fit: cover;\n      }\n    }\n  }\n\n  small {\n    font-size: 10px;\n    opacity: .8;\n  }\n}\n</style>",".multiple-order-bump {\n  border-radius: 4px !important;\n  border-color: #C08811 !important;\n  border: 1px dashed rgba(0, 0, 0, 0.3);\n  box-shadow: none;\n}\n.multiple-order-bump > .card-header {\n  color: #803F02;\n  border-radius: 4px !important;\n  padding: 8px 16px;\n  background: #FBEBC1;\n  font-weight: bold;\n  font-size: 16px;\n  border-bottom: none;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.multiple-order-bump .price {\n  white-space: nowrap;\n}\n.multiple-order-bump .description {\n  display: block;\n  font-size: 14px;\n  line-height: 130%;\n  color: #928F98;\n}\n.multiple-order-bump > .card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 16px 12px;\n}\n.multiple-order-bump > .card-body hr {\n  border-color: rgba(0, 0, 0, 0.3);\n}\n.multiple-order-bump > .card-body .card {\n  border-radius: 4px !important;\n  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1215686275);\n}\n.multiple-order-bump > .card-body .media {\n  align-items: center;\n}\n.multiple-order-bump > .card-body .media img {\n  max-width: 56px;\n  max-height: 56px;\n  min-width: 56px;\n  min-height: 56px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n.multiple-order-bump small {\n  font-size: 10px;\n  opacity: 0.8;\n}\n\n/*# sourceMappingURL=multiple-order-bump.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/multiple-order-bump.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__